// extracted by mini-css-extract-plugin
module.exports = {"cityPeopleContainer":"styles_cityPeopleContainer__3lCZm","cityPeopleLabel":"styles_cityPeopleLabel__QDcs1","cityInputPeople":"styles_cityInputPeople__2_t42"};